export default "__VITE_ASSET__84b6fb01__"